import React from 'react';
import { Button, Grid, Typography } from '@material-ui/core';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import CardCommon from '../../../../components/card/CardCommon';
import CategoryMenuListStrip from './CategoryMenuListStrip';
import CategoryMenuList from './CategoryMenuList';

export interface ProductListProps {
  products: any[]; // Consider a more specific type for 'any'
  removedLinkedIdLists: any; // Consider a more specific type for 'any'
  handleUpdateIdList: (item: any) => void;
  handleClickLinkedId: (item: any) => void;
  handleClearStrip: (item: any) => void;
  handleNavigate: (item: any, level: number, parentData: any) => void;
  isColorChange: boolean;
  revertExpand: boolean;
  handleSelectProduct: (item: any) => void;
  category: any;
  selectedWrapperIdList: any;
  setSelectedWrapperIdList: (ids: any) => void;
  isOwner: boolean;
  editableRewardDetails: any;
}

// Recursive Component
const ProductList: React.FC<ProductListProps> = ({
  products,
  removedLinkedIdLists,
  handleUpdateIdList,
  handleClickLinkedId,
  handleClearStrip,
  handleNavigate,
  isColorChange,
  revertExpand,
  handleSelectProduct,
  category,
  selectedWrapperIdList,
  setSelectedWrapperIdList,
  isOwner,
  editableRewardDetails,
}) => {
  return (
    <>
      {products.map((product, index) => {
        const isWrapper = !!product.wrapper;
        const isStripVisible = isWrapper && removedLinkedIdLists[product.id?.toString()];
        const isFirstItem = index === 0;

        return (
          <React.Fragment key={product.id}>
            <Grid item md={6} xs={12} lg={4}>
              {isWrapper ? (
                <div>
                  <CategoryMenuListStrip
                    item={product}
                    handleClickLinkedId={handleClickLinkedId}
                    isColorChange={isColorChange}
                    handleUpdateIdList={handleUpdateIdList}
                    category={product}
                  />
                </div>
              ) : (
                <CardCommon
                  backgroundColor={"default"}
                  style={{ borderRadius: "10px", marginTop: "12px" }}
                >
                  <CategoryMenuList
                    item={product}
                    removedLinkedIdList={removedLinkedIdLists}
                    handleUpdateIdList={handleUpdateIdList}
                    index={0}
                    data={product}
                    isColorChange={isColorChange}
                    revertExpand={revertExpand}
                    handleSelectProduct={handleSelectProduct}
                    category={category}
                    selectedWrapperIdList={selectedWrapperIdList}
                    setSelectedWrapperIdList={setSelectedWrapperIdList}
                    isOwner={isOwner}
                    editableRewardDetails={editableRewardDetails}
                  />
                </CardCommon>
              )}
            </Grid>
            {/* Recursively render if wrapper is present and visible */}
            {isStripVisible && (
              <Grid
                container
                spacing={2}
                style={{
                  paddingLeft: "15px",
                  paddingRight: "15px",
                  marginBottom: "8px",
                  marginTop: "8px",
                }}
              >
                <CardCommon
                  backgroundColor={"entity_highlight_directory_background"}
                  style={{ width: "100%", overflow: "hidden" }}
                >
                  <Grid container spacing={2} style={{ padding: "14px 14px 6px 14px" }}>
                    {/* Breadcrumb section based on directory levels */}
                    {isFirstItem && product.wrapper && (
                        <Grid item xs={12} style={{ display: 'flex', justifyContent: 'start', alignItems: 'center' }}>
                            <Button onClick={() => handleNavigate(product, 1, product)}>
                                <Typography variant="h6">{product.name}</Typography>
                            </Button>
                            <Button onClick={() => handleClearStrip(product)}>
                                <HighlightOffIcon />
                            </Button>
                        </Grid>
                    )}
                    {/* Recursive Call */}
                    <ProductList 
                      products={product.wrapper.filter((data: any) => 
                        removedLinkedIdLists[data?.directoryId?.toString()] &&
                        removedLinkedIdLists[data.directoryId.toString()].directoryLevel + 1 === data.directoryLevel &&
                        removedLinkedIdLists[data.directoryId.toString()].id === data.directoryId
                      )}
                      {...{
                        removedLinkedIdLists,
                        handleUpdateIdList,
                        handleClickLinkedId,
                        handleClearStrip,
                        handleNavigate,
                        isColorChange,
                        revertExpand,
                        handleSelectProduct,
                        category,
                        selectedWrapperIdList,
                        setSelectedWrapperIdList,
                        isOwner,
                        editableRewardDetails,
                      }}
                    />
                  </Grid>
                </CardCommon>
              </Grid>
            )}
          </React.Fragment>
        );
      })}
    </>
  );
};

export default ProductList;